import React, { createContext, useState, useContext, useEffect } from "react";
import { get_user } from "../../api/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const UserContext = createContext();

export const useAuth = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null); // user can be an object like {name, email, etc.}
  const handleSignIn = async () => {
    try {
      let userData = await get_user();
      if (userData.data) {
        setUser(userData.data);
      } else {
        toast.error(userData.data.error.message);
        console.log(userData.data.error);
      }
    } catch (e) {
      toast.error(e);
      // alert(e);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("token")) {
      handleSignIn();
    }
  }, []);
  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};
